import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { useContent } from "../contexts/ContentContext";

export default function FAQ() {
  const { content } = useContent();
  const { faqs } = content;
  return (
    <section id="faq" className="py-20 lg:py-28 bg-white">
      <div className="max-w-4xl mx-auto px-4 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-block px-3 py-1 rounded-full bg-emerald-50 text-[#0a4f47] text-xs font-semibold tracking-wider mb-4">
            FAQS
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-slate-900">
            Frequently Asked <span className="text-orange-500">Questions</span>
          </h2>
        </div>
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem
              key={f.q || `faq-${i}`}
              value={`q-${i}`}
              className="border border-slate-200 rounded-xl px-5 data-[state=open]:border-orange-300 data-[state=open]:bg-orange-50/30"
            >
              <AccordionTrigger className="text-left font-bold text-slate-900 hover:text-[#0a4f47] hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
